export function sliceEmail(email) {
  if (email?.slice(email.indexOf("@"))?.split("")[0] === "@") {
    return email?.slice(email?.indexOf("@") + 1);
  }
}
